import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AccountCategory } from '@account-users/account/models/AccountCategory';

@Component({
  selector: 'app-account-category-filter',
  templateUrl: './account-category-filter.component.html',
  styleUrls: ['./account-category-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountCategoryFilterComponent {
  @Input() filter: string[];
  @Input() accountCategories: AccountCategory[] = [];
  @Output() filterByCategory = new EventEmitter<{
    category: string;
    toggle: boolean;
  }>();
}
